<template>
  <div class="app-header"
       v-loading.fullscreen.lock="loading"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <i class="left header-logo iconfont icon-font-logo"></i>
    <img class="left" src="~@/assets/icon/logo.png" style="height: 46px;padding: 7px 0;" />
    <div class="left header-title">报告平台</div>
    <div class="right">
      <i class="left header-name iconfont icon-font-name" style="cursor:default"> {{ userName }}</i>
      <i class="left header-notice iconfont icon-font-un-read" @click="$store.commit('changeMsgWindow')"> 全部消息({{ $store.state.unReadNewsCount }})</i> 
      <i class="left header-logout iconfont icon-font-logout "
         v-on:click="logout"> 注销</i>
      <i class="left header-pwd iconfont icon-font-pwd"
         v-on:click="editPwd"> 修改密码</i>
    </div>

    <el-dialog :visible.sync="dlgEditPwdVisible"
               title="修改密码"
               class="edidPwd-dialog"
               :close-on-click-modal="false"
               :show-close="false"
               v-on:close="closeEditPwdVisible">
      <el-form ref="userPwdForm"
               :model="userPwdForm"
               :rules="pwdRules">
        <el-form-item label="旧 密 码 " class="col-input special-label" prop="oldPwd">
          <el-input v-model="userPwdForm.oldPwd"
                    type="password"
                    show-password
                    v-on:keyup.enter.native="frmEnter( 'oldPwd','newPwd')"
                    ref="oldPwd"
                    auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="新 密 码  " class="col-input special-label" prop="newPwd">
          <el-input v-model="userPwdForm.newPwd"
                    type="password"
                    show-password
                    ref="newPwd"
                    v-on:keyup.enter.native="frmEnter( 'newPwd','confirmPwd')"
                    auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="密码确认" class="col-input" prop="confirmPwd">
          <el-input v-model="userPwdForm.confirmPwd"
                    type="password"
                    show-password
                    ref="confirmPwd"
                    v-on:keyup.enter.native="saveEditPwd"
                    auto-complete="new-password"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" v-on:click="saveEditPwd" icon="iconfont icon-font-success" class="confirm-btn">确定</el-button>
        <el-button  type="default" class="cancel" v-if="showPwdCancelBtn"  icon="iconfont icon-font-cancel" v-on:click="dlgEditPwdVisible=false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import request from '@/utils/request'
  export default {
    name: "Header",
    props: {
     
    },
    data() {
      const validateOrgPassword = (rule, value, callback) => {
        if (value == "") {
          callback(new Error("请输入密码"));
        } else {
          callback();
        }
      };
      const validatePassword = (rule, value, callback) => {
        if (value == "") {
          callback(new Error("请输入密码"));
        } else {
          if (this.userPasswrodRegex && this.userPasswrodRegex != ".") {
            if (!new RegExp(this.userPasswrodRegex).test(value)) {
              callback(new Error(this.userPasswrodRemark))
            }
            else {
              callback();
            }
          }
          else {
            callback();
          }
        }
      };
      const validatePasswordConfirm = (rule, value, callback) => {
        if (value == "") {
          callback(new Error("请输入密码"));
        } else if (value != this.userPwdForm.newPwd) {
          callback(new Error("两次密码输入不一致，请重新输入"));
        }
        else {
          callback();
        }
      };
      return {
        loading: false,
        dlgEditPwdVisible: false,
        showPwdCancelBtn: true,
        userName: "",
        userPwdForm: {
          oldPwd: '',
          newPwd: '',
          confirmPwd: ''
        },
        pwdRules: {
          oldPwd: [
            { required: true, trigger: "blur", validator: validateOrgPassword },
          ],
          newPwd: [
            { required: true, trigger: "blur", validator: validatePassword },
          ],
          confirmPwd: [
            { required: true, trigger: "blur", validator: validatePasswordConfirm },
          ]
        },
        userPasswrodRegex: '',
        userPasswrodRemark: '',
      };
    },
    computed: {},
    mounted() {
      let userInfo = this.common.getCookie("userInfo");
      if (userInfo) {
        this.userName = userInfo.UserName;
      }
      if (this.common.IsNull(this.userName)) {
        this.$router.push({ path: "/" });
        return;
      }
      this.getSysParameter();
    },  
    methods: {
      logout() {
        this.$confirm('确认是否注销此账号？','注销确认', {
          cancelButtonClass:'btn-custom-cancel iconfont icon-font-cancel btn-custom-center',
          confirmButtonClass:' iconfont icon-font-success',
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          showClose: false,
          iconClass: 'iconfont icon-font-warning',
          customClass: 'custom-message-box-2',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.common.setCookie("userInfo", "");
          this.common.setCookie("token", "");
          this.$router.push({ path: "/" });
        }).catch(() => { });
      },
      //修改密码弹框
      editPwd() {
        this.dlgEditPwdVisible = true;
        this.$nextTick(() => {
          if (this.$refs['userPwdForm'])
            this.$refs['userPwdForm'].clearValidate();
          if (this.$refs['oldPwd'])
            this.$refs['oldPwd'].focus();
        })
      },
      //保存修改密码信息
      saveEditPwd() {
        this.$refs['userPwdForm'].validate((valid) => {
          if (valid) {
            const param = {
              OldPassword: this.userPwdForm.oldPwd,
              NewPassword: this.userPwdForm.newPwd,
            }
            request.post('/api/basedata/ModifyPwd', param).then((r) => {
              if (r.Flag == "1") {
                this.$message.success('修改密码成功');
                this.showPwdCancelBtn = true;
                this.dlgEditPwdVisible = false;
                this.clearFrmEditPwdInfo();
                
              } else {
                this.$alert('修改失败：' + r.ErrorMsg, {
                  confirmButtonText: '确定',
                  confirmButtonClass: 'iconfont icon-font-success',
                  iconClass: 'iconfont icon-font-error',
                  customClass: 'custom-message-box-1',
                  dangerouslyUseHTMLString: true,
                  showClose: false
                });
                this.dlgEditPwdVisible = true;
                this.clearFrmEditPwdInfo();
              }
            }).catch((r) => {

            })
          }
        })
      },
      clearFrmEditPwdInfo() {
        this.userPwdForm = {
          oldPwd: '',
          newPwd: '',
          confirmPwd: ''
        },
          this.$nextTick(() => {
            this.$refs['userPwdForm'].clearValidate();
          })
      },
      closeEditPwdVisible() {
        this.clearFrmEditPwdInfo();
      },
      getSysParameter() {
        this.loading = true;
        request.post("/api/BaseData/GetWebConfigs", {
          NameList: ['UserPasswrodRegex', 'UserPasswrodRemark', 'HideSensitiveData']
        }).then((r) => {
          this.loading = false;
          this.userPasswrodRegex = r.UserPasswrodRegex;
          this.userPasswrodRemark = r.UserPasswrodRemark;
          this.common.sethideSensitiveData(r.HideSensitiveData);

          if (this.userPasswrodRemark && this.userPasswrodRemark != '' && this.userPasswrodRemark != '.') {
            this.loading = true;
            request.post("/api/Login/CheckUserPassword", {}).then((r) => {
              this.loading = false;
              if (!r.Success) {
                this.$alert('密码太过简单，需要调整，' + this.userPasswrodRemark, {
                  confirmButtonText: '确定',
                  iconClass: 'iconfont icon-font-warning',
                  dangerouslyUseHTMLString: true,
                  showClose: false
                });
                this.showPwdCancelBtn = false;
                this.editPwd();
              }
            });
          }
        });
      },

      frmEnter(curEle, nextEle, callback) {
        this.$refs['userPwdForm'].validateField(curEle, error => {
          if (!error) {
            if (callback) {
              return callback();
            }
            this.$refs[nextEle].focus();
          } else {
            this.$refs[curEle].focus();
          }
        })
      },
    },
  };
</script>

<style lang="scss" scoped="">
  .app-header {
    height: 60px;
    line-height: 60px;
    background: #fff;
  }

    .app-header .header-logo {
      float: left;
      height: 100%;
      font-size: 30px;
      color: #00589c;
      padding-left: 15px;
    }

    .app-header .header-title {
      height: 100%;
      font-size: 26px;
      font-weight: bold;
      font-family: source;
      color: rgba(27,123,212,1);
      margin: 0 15px;
      letter-spacing: 5px;
    }

    .app-header .header-name,
    .app-header .header-notice,
    .app-header .header-logout,
    .app-header .header-pwd {
      line-height: 60px;
      color: #333;
      font-style: normal;
      font-size: 14px;
      font-family: Regular;
      min-width: 120px;
      text-align: center;
     
    }
      .app-header .header-notice,
      .app-header .header-logout,
      .app-header .header-pwd{
        cursor:pointer;
      }
      .app-header .header-notice:hover,
      .app-header .header-logout:hover,
      .app-header .header-pwd:hover {
        background: #f7f9fb;
        border-radius: 8px;
      }
  .edidPwd-dialog .el-form .el-form-item{
    margin-bottom:14px;
  }
  .edidPwd-dialog .cancel {
    margin-left: 16px;
    color: rgba(255,255,255,1) !important;
    border-color: rgba(198,205,215,1) !important;
    background-color: rgba(198,205,215,1) !important;
  }
  /*修改密码弹框*/
  .edidPwd-dialog >>> .el-dialog {
    width: 420px;
    height: 320px;
    box-shadow: 0 0 9px 3px rgba(104,110,113,0.25);
    background-color: rgba(251,253,255,1);
    border-radius: 4px;
  }

  .edidPwd-dialog >>> .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
    color: rgba(27,154,238,1);
  }

  .edidPwd-dialog >>> .el-dialog__body {
    padding: 5px 10px 0px;
  }

  .edidPwd-dialog >>> .el-input {
    width: 280px;
    height: 38px;
  }

  .edidPwd-dialog >>>  .el-input__inner {
    width: 280px;
    height: 38px;
    line-height: 38px;
    color: rgba(51,51,51,1);
    font-weight: bold;
    font-size: 14px;
  }

  .edidPwd-dialog >>> .el-form-item__label {
    letter-spacing: 2.5px;
    color: #333;
  }

  .edidPwd-dialog >>> .el-button {
    width: 80px;
    height: 36px;
    /*margin-bottom: 20px;*/
    padding: 0;
  }

  .edidPwd-dialog >>> .el-dialog__footer {
    padding: 10px 20px 15px !important;
  }

  .edidPwd-dialog >>> .el-form-item__error {
    padding-left: 100px;
  }

  .edidPwd-dialog >>> .cancel {
    border-color: #409eff;
    color: #409eff;
  }

  .edidPwd-dialogg >>> .cancel:hover {
    border-color: #409eff;
    color: #409eff;
  }

  .edidPwd-dialog >>> .el-select {
    width: 298px;
  }

  .edidPwd-dialog .special-label >>> .el-form-item__label {
    letter-spacing: 3px;
  }


</style>



// WEBPACK FOOTER //
// src/layout/compones/header.vue